import React from "react";

import { faHashtag } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import JumpToResultWrapper from "~/search/JumpTo/JumpToResult/JumpToResultWrapper";

import type { JumpToResultSearch_result$data as JumpToResultType } from "~/__generated__/JumpToResultSearch_result.graphql";

interface JumpToTagResultProps {
	tag: Extract<JumpToResultType, { __typename: "Tag" }>;
	index?: number;
}

export default function JumpToTagResult({ tag, index }: JumpToTagResultProps) {
	return (
		<JumpToResultWrapper
			index={index}
			to={`/search/?q=%23${tag.label}`}
			icon={<FontAwesomeIcon icon={faHashtag} />}
			title={tag.label}
		/>
	);
}
